export default "__VITE_ASSET__DzdrdNSF__"